export default "/_next/static/chunks/fonts/Cormorant-Medium-latin-1b238364e6c14bd37d509f2ccf5258a2.woff2";